import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PATH } from '../enums/routes.enum';
import { AuthStore } from '../../features/login/store/auth.store';

export const AuthGuard: CanActivateFn = () => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  if (auth.token()) {
    return true;
  } else {
    router.navigate([PATH.ROOT]);
    return false;
  }
};
